import { buildEnumMapProvider } from '../../utils/enum-map';
import { ApiErrorCode } from '../open-api/open-api-clients';

export const apiErrorCodeProvider = buildEnumMapProvider(ApiErrorCode, getEnumText);

function getEnumText(value: ApiErrorCode): string {

    switch (value) {

        case ApiErrorCode.CaptchaValidationFailed:
            return $localize`Suspicious activity detected. Try again later.`;
    }
}

